import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';

export default class LanguageService {
	webApiService: WebApiService;
	GetLanguagesEvent = new Events<WsResponseModelT<Array<String>>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('LanguageService', 'GetLanguages', (res: WsResponseModelT<Array<String>>) => {
			self.GetLanguagesEvent.trigger(res);
		});
	}
	GetLanguages() { 	
        this.webApiService.send('LanguageService', 'GetLanguages' );
    }
	 // async methods
	async getLanguagesAsync(): Promise<Array<String>> {
		return EventToAsyncDecorator.getInstance().bind(this.GetLanguages.bind(this), this.GetLanguagesEvent)();
	}
}